import React, { useEffect, useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import Style from "./ProductHomeSlider.module.css";
import ProductSliderItem from "../../../Component/ProductSliderItem/ProductSliderItem";
import { postAddToFavoriteApi, postRemoveFavoriteApi } from "../../../Api/ClientServices";
import { succToast } from "../../../Toast/Toast";
const ProductHomeSlider = ({ title, sliderData }) => {
  const [localSliderData, setLocalSliderData] = useState(sliderData);
  const [sliderRef, sliderInstance] = useKeenSlider({
    mode: "free",
    renderMode: "performance",
    loop: true,
    breakpoints: {
      "(min-width: 280px)": {
        slides: { perView: 2.5, spacing: 5 },
        rtl: true,
      },
      "(min-width: 600px)": {
        slides: { perView: 3.5, spacing: 5 },
        rtl: true,
      },
      "(min-width: 1000px)": {
        slides: { perView: 4.5, spacing: 5 },
        rtl: true,
      },
    },
    slides: { perView: 1 },
    rtl: true,
  });

  // Update local state when sliderData prop changes
  useEffect(() => {
    setLocalSliderData(sliderData);
  }, [sliderData]);

  // Reinitialize slider when data changes
  useEffect(() => {
    if (sliderInstance.current) {
      sliderInstance.current.update();
    }
  }, [localSliderData, sliderInstance]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderInstance && sliderInstance.current) {
        try {
          sliderInstance.current.next();
        } catch (e) {
        }
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [sliderInstance]);

  const addFavoriteHandler = (itemData) => {
    const productId = { id: itemData.id };
    const isFavorited = parseInt(itemData.favorite) === 1;

    setLocalSliderData((prevData) =>
      prevData.map((item) =>
        item.id === itemData.id
          ? { ...item, favorite: isFavorited ? "0" : "1" }
          : item
      )
    );

    // Call API
    if (isFavorited) {
      postRemoveFavoriteApi(productId, (res) => {
        if (res.status === 1) {
          succToast(res.message);
        }
      });
    } else {
      postAddToFavoriteApi(productId, (res) => {
        if (res.status === 1) {
          succToast(res.message);
        }
      });
    }
  };
  return (
    <>
      <div className={Style.sliderTitleHolder}>
        <h3>{title}</h3>
        {/* <Link>
          دیدن همه
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link> */}
      </div>
      <div ref={sliderRef} className={`${Style.SliderSection} keen-slider`}>
        {localSliderData?.map((item) => {
          return (
            <ProductSliderItem item={item} key={item.id} addFavorite={addFavoriteHandler}/>
          );
        })}
      </div>
    </>
  );
};

export default ProductHomeSlider;
